
import { baseClasses } from '@weatherbug/common';

const nationalOutlookVideoUri = '/api/popups';
const nationalOutlookVideoKey = 'wbnationaloutlookpopups';

const { PulseBaseProvider } = baseClasses;

const getNationalOutlookVideoValidationFunction = (result) => {
    return result && result?.Video?.Links?.[0];
};

export class NationalOutlookProvider extends PulseBaseProvider {
    constructor(authId, secret, options, logger) {
        super(authId, secret, options, logger);
        window.storage.sync[nationalOutlookVideoKey] = this.nationalOutlookSyncer.bind(this);
    }

    async nationalOutlookSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
                id: parsedQParams.outlookVideoId,
                type: parsedQParams.type
        };
        return await super.syncData(key, id, queryParams, nationalOutlookVideoUri, resolve, reject, getNationalOutlookVideoValidationFunction, pulseApi, null, null, false);
    }

    async getNationalOutlook(outlookVideoId, type='Video') {
        const syncParams = {
            outlookVideoId,
            type,
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(nationalOutlookVideoKey, id, syncParams);
    }

}
